import { store } from '../../../redux/store';
import queryString, { ParsedQuery } from 'query-string';
import { COUNTRY_WISE_LE_CONFIG } from '../Constants/Constants';

type EUCountries = 'Spain' | 'ESP';
type LegalEntity = 'CDLEU';

export const CheckAffiliateBasedOnLEAndCountry = (countryList: string[]) => {
    const { user } = store.getState();
    const { ctry, le }: ParsedQuery<string> = queryString.parse(window.location.search);
    const { affiliate: { legal_entity = '', billing_country = '' } = {} } = user.affiliateDetails || {};
    const legalEntity: string = !!le ? le as LegalEntity : legal_entity;
    const billingCountry: string = !!ctry ? ctry as EUCountries : billing_country;
    const isAffiliateConfigMatched: boolean = countryList.some((countryCode) => {
        const applicableLE: string[] = COUNTRY_WISE_LE_CONFIG[countryCode].applicableLE;
        const countryNamePossibilities: string[] = COUNTRY_WISE_LE_CONFIG[countryCode].countryNamePossibilities;

        return applicableLE.includes(legalEntity) && countryNamePossibilities.includes(billingCountry);
    })

    return isAffiliateConfigMatched;
};